import React from "react";

import InputV2 from "@tvg/atomic-ui/_molecule/InputV2";
import SelectMolecule from "@tvg/atomic-ui/_molecule/Select";
import InputMask from "@tvg/atomic-ui/_molecule/InputMask";
import { get, noop } from "lodash";

import { Title, Text, Row, AddressFormContainer } from "./styled-components";

export const AddressForm = ({
  title,
  description,
  states,
  labels,
  visible,
  isFormDirty,
  zipOnBlur,
  zipOnChange,
  stateOnChange,
  streetOnBlur,
  streetOnChange,
  detailsOnBlur,
  cityOnBlur,
  detailsOnChange,
  cityOnChange,
  qaLabel,
  formSection,
  autoFocus,
  isLast,
  hasPreloadedInputs
}) => (
  <AddressFormContainer
    visible={visible}
    isLast={isLast}
    data-qa-label={qaLabel}
  >
    <Title fontSize={18} tag="h2" uppercase={false} qaLabel="title">
      {title}
    </Title>
    {!!description && <Text qaLabel="text">{description}</Text>}
    <InputV2
      name="street"
      autoCompleteValue={`${formSection} address-line1`}
      hasPreloadedInputs={hasPreloadedInputs}
      debouncedValueCallback={streetOnBlur}
      customHandleChange={streetOnChange}
      isFormDirty={isFormDirty}
      label={get(labels, "streetTitle", "")}
      qaLabel="address-street"
      placeholder={get(labels, "streetPlaceholder", "")}
      marginBottom={12}
      autoFocus={autoFocus}
    />
    <InputV2
      name="details"
      autoCompleteValue={`${formSection} address-line2`}
      hasPreloadedInputs={hasPreloadedInputs}
      debouncedValueCallback={detailsOnBlur}
      customHandleChange={detailsOnChange}
      isFormDirty={isFormDirty}
      label={get(labels, "detailsTitle", "")}
      optionalLabel="optional"
      qaLabel="address-details"
      marginBottom={12}
    />
    <InputMask
      name="zip"
      autoComplete={`${formSection} postal-code`}
      label={get(labels, "zipTitle", "")}
      qaLabel="address-zip"
      inputMode="number"
      letterSpacing={1}
      mask="99999"
      maskChar="_"
      placeholder={get(labels, "zipPlaceholder", "")}
      marginBottom={12}
      hasPreloadedInputs={hasPreloadedInputs}
      debouncedValueCallback={zipOnBlur}
      customHandleChange={zipOnChange}
    />
    <Row>
      <InputV2
        name="city"
        autoCompleteValue={`${formSection} address-level2`}
        hasPreloadedInputs={hasPreloadedInputs}
        debouncedValueCallback={cityOnBlur}
        customHandleChange={cityOnChange}
        isFormDirty={isFormDirty}
        label={get(labels, "cityTitle", "")}
        qaLabel="address-city"
        marginBottom={12}
      />
      <SelectMolecule
        name="state"
        autoCompleteValue={`${formSection} address-level1`}
        label={get(labels, "stateTitle", "")}
        qaLabel="address-state"
        defaultValue={get(labels, "statePlaceholder", "")}
        handleCustomChange={stateOnChange}
        options={states}
      />
    </Row>
  </AddressFormContainer>
);

AddressForm.defaultProps = {
  title: "",
  description: "",
  states: [],
  visible: true,
  labels: {},
  isFormDirty: false,
  onZipChange: noop,
  onStateChange: noop,
  streetOnChange: noop,
  detailsOnChange: noop,
  cityOnChange: noop,
  formSection: "section-one",
  autoFocus: false
};
